/**
 * Automation version numbers have the format `V<n>` (e.g. `V1`, `V12`, with the
 * numeric part being an arbitrary length). Returns the numeric part so versions
 * can be compared.
 */
export const parseVersionNumber = (versionNumber: string): number =>
  Number(versionNumber.replace(/^V/i, ''))
